import React from 'react';
import _ from 'lodash';
import config from 'config';

const coachIcon =
  'https://res.cloudinary.com/dljcvcx8l/' +
  'image/upload/v1556128910/' +
  'Square_Logo_Black_wodins.jpg';

const trybePubKey = config.stripePubKey;

class UserPayment extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
    };
  }

  componentDidMount(){
    this.loadStripe();
  }

  initStripe = () => {
    const pubKey = this.getURLVal('pk');
    const stripe = Stripe(pubKey || trybePubKey);

    const sessionId = this.getURLVal('sessionId');

    stripe.redirectToCheckout({
      sessionId,
    }).then(result => {
      console.log('result', result)
      // If `redirectToCheckout` fails due to a browser or network
      // error, display the localized error message to your customer
      // using `result.error.message`.
    });
  }

  loadStripe = () => {
    const script = document.createElement('script');
    script.src = 'https://js.stripe.com/v3/';
    script.onload = this.initStripe;
    document.head.appendChild(script);
  }


  openStripe = (e) => {

  }

  getURLVal(key){
    let result = null;
    const query = window.location.search.substring(1);
    const strings = query.split('&');
    _.each(strings, (string) => {
      const pair = string.split('=');
      let currKey = pair[0];
      if(currKey == key){
        let currVal = pair[1];
        currVal = currVal.replace('+',' ');
        result = currVal;
      }
    });

    return result;
  }

  renderPurchaseButton(){
    const { isAwaitingPaidConf, showPaidConf } = this.state;
    const show = showPaidConf ? false : true;
    if(!show){
      return null;
    }

    const showPayButton = isAwaitingPaidConf ? false : true;

    return (
      <div className='flex-column'>
        { showPayButton ?
          <div className='flex-column'>
            <img
              src='https://res.cloudinary.com/dljcvcx8l/image/upload/v1556128910/Square_Logo_Black_wodins.jpg'
              className='coach-logo' />
            <div className='title-text'>Upgrade Membership Access</div>
            <div className='flex-column align-start'>
              <div className='benefit-row'>
                <img
                  src={require('../../images/confirmationCheckmark.png')}
                  className='confirmation-checkmark-sm' />
                <div className='benefit-text'>Private community with Tom</div>
              </div>
              <div className='benefit-row'>
                <img
                  src={require('../../images/confirmationCheckmark.png')}
                  className='confirmation-checkmark-sm' />
                <div className='benefit-text'>Coaching feedback and technique cues</div>
              </div>
              <div className='benefit-row'>
                <img
                  src={require('../../images/confirmationCheckmark.png')}
                  className='confirmation-checkmark-sm' />
                <div className='benefit-text'>Full access to content</div>
              </div>
              <div className='benefit-row'>
                <img
                  src={require('../../images/confirmationCheckmark.png')}
                  className='confirmation-checkmark-sm' />
                <div className='benefit-text'>Programs for all levels</div>
              </div>
              <div className='benefit-row'>
                <img
                  src={require('../../images/confirmationCheckmark.png')}
                  className='confirmation-checkmark-sm' />
                <div className='benefit-text'>Hundreds of workouts</div>
              </div>
              <div className='benefit-row'>
                <img
                  src={require('../../images/confirmationCheckmark.png')}
                  className='confirmation-checkmark-sm' />
                <div className='benefit-text'>Adjustable exercises for all skill levels</div>
              </div>
            </div>
            <button className='custom-button' onClick={ this.openStripe }>
              Upgrade Now
            </button>
          </div>
          :
          <div className='flex-column'>
            <div className='step-title-text'>One moment while we process your payment...</div>
            <div className='step-title-text'>This may take up to 15 seconds.</div>
            <div className='loader'></div>
            <div className='step-title-text'>Until directed to the confirmation page, no charge will be made.</div>
          </div>
        }
      </div>
    )
  }

  renderConfirmation(){
    const showPaidConf = this.state.showPaidConf ? true : false;
    if(!showPaidConf) return null;

    return (
      <div className='flex-column align-center flex-center'>
        <div className='congrat-text'>
          Membership Successfully Upgraded
        </div>
        <img
          src={require('../../images/confirmationCheckmark.png')}
          className='confirmation-checkmark-lrg' />
      </div>
    )
  }

  renderLoading = () => {
    return (
      <div className='full-scene flex-column'>
        <div className='loading-text'>Preparing secure checkout...</div>
        <div className='app-start-loader'>
        </div>
      </div>
    )
  }

  render() {
    return (
      <div className='flex-column user-payment-checkout-container'>
        { this.renderLoading() }
      </div>
    );
  }
}

module.exports = UserPayment;


// WEBPACK FOOTER //
// ./src/components/payments/UserPaymentCheckout.js